<!-- angly Menu -->
<angly-menu *ngIf="!isV4Menu"></angly-menu>
<kla-menu *ngIf="isV4Menu"></kla-menu>
